import styled from '@emotion/styled'

export const CardPlanItemWrapStyle = styled.div`
  display: flex;
  flex-wrap: ${props => (props.wrap ? 'wrap' : 'nowrap')};
  flex-direction: ${props => (props.column ? 'column' : 'row')};
  gap: 2rem;
  justify-content: ${props => (props.column ? 'flex-start' : 'space-between')};
  width: 100%;

  .card-plan-item {
    flex: ${props =>
      props.column
        ? '0 0 auto'
        : '1 1 calc(50% - 1rem)'}; /* column: 1 per row, row: 2 per row */
    max-width: ${props => (props.column ? '100%' : '16.5625rem')}; /* 265px */
    display: flex;
    gap: 0.5rem;
    border-radius: 0.625rem; /* 10px */
    padding: 1rem 1.25rem;
    background: white;
    color: black;
    box-shadow: 0px 1px 3px 0px #00000033, 0px 2px 1px -1px #0000001f,
      0px 1px 1px 0px #00000024;
    cursor: pointer;

    .item-content-wrap {
      display: flex;
      flex-direction: column;
      gap: 0.25rem;

      .plan-item-radio-label {
        font-family: 'Montserrat', sans-serif;
        font-weight: 600;
        font-size: clamp(1rem, 1.5vw, 1.125rem); /* 16px–18px */
        line-height: 1.625rem; /* 26px */
        color: #231f20;
      }

      .plan-item-price {
        font-family: 'Open Sans', sans-serif;
        font-weight: 300;
        font-size: clamp(1.5rem, 3vw, 2.25rem); /* 24px–36px */
        line-height: 1;
        color: #231f20;
      }

      .plan-item-subtext {
        font-family: 'Open Sans', sans-serif;
        font-weight: 400;
        font-size: 0.875rem; /* 14px */
        line-height: 1.375rem; /* 22px */
      }
    }
  }
  .card-plan-item.checked {
    border: 1px solid #5378fc;
  }
  .card-plan-item.disabled {
    cursor: not-allowed;
    background: #f8f8f8d1;
    color: #1212128f;
    .plan-item-radio-label,
    .plan-item-price,
    .plan-item-subtext {
      color: #1212128f;
    }
  }
`
